import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AutoSizer, List, InfiniteLoader } from 'react-virtualized';
import BoardItem from '../../../../components/BoardGroup/BoardItem/BoardItem';
import {
  actionMultiCity,
  actionMultiStation,
  actionMultiVehicle,
  actionSendSocketData,
} from '../../../../redux/action';
import ActionType from '../../../../redux/actionType';
import { RootState } from '../../../../redux/store';
import debounce from 'lodash/debounce';
import { formatBoardGroupByFilterType } from '../../util';
import './index.scss';
import { ConnectionState } from '../../../../redux/type';
import { Button, message } from 'antd';
import RequestApi from '@/fetch/bussiness/attention';
import { showModal } from '@/components/Common/Modal';
import { HttpStatusCode } from '../../../../fetch/core/constant';

let loadedRowsMap: any = {};
type BoardModeProps = {
  handleClickStopItem: AnyFunc;
  handleScheduleModel: AnyFunc;
  totalSize?: number;
  searchCondition: {
    vehicleBusinessType: string;
    vehicleUseCaseList: string[];
    sortType: string;
    currentCategory: string;
  };
  cockpitNum: string;
};

let timer: any = null;
const BoardMode = (props: BoardModeProps) => {
  const requestApi = new RequestApi();
  const dispatch = useDispatch();
  const common = useSelector((state: RootState) => state.common);
  const cockpitInfo = useSelector((state: RootState) => state.cockpitInfo);
  const containerRef = useRef<HTMLDivElement>(null);
  const [pageinnation, setPageinnation] = useState({
    pageSize: 0,
    currentPage: 1,
  });
  const [containerHeight, setContainerHeight] = useState(0);
  const { realTimeBoardData, vehicle, station, city } = common;
  const [boardList, setBoardList] = useState<any>([]);
  const { searchCondition, totalSize, handleClickStopItem } = props;
  const boardListData = useMemo(
    () => formatBoardGroupByFilterType(realTimeBoardData, common.vehicle),
    [realTimeBoardData.timeStamp],
  );

  const fetchBoardList = (currentPage: number, pageSize: number) => {
    if (pageSize === 0) {
      return;
    }
    const data = {
      eventType: ActionType.MULTI_VEHICLE,
      data: {
        ...searchCondition,
        cockpitNumber: props.cockpitNum === 'user' ? null : props.cockpitNum,
        multiVehiclePageList: [
          {
            category: searchCondition.currentCategory,
            pageNum: currentPage,
            pageSize: pageSize,
          },
        ],
      },
    };

    dispatch(actionSendSocketData(JSON.stringify(data)));
  };

  useEffect(() => {
    if (boardListData.length > 0) {
      if (!boardList[pageinnation.currentPage - 1]) {
        const arr = boardList.concat([boardListData]);
        setBoardList([...arr]);
      } else {
        boardList.splice(pageinnation.currentPage - 1, 1, boardListData);
        setBoardList([...boardList]);
      }
    } else {
      if (pageinnation.currentPage == 1) {
        setBoardList([]);
      }
    }
  }, [boardListData]);

  useEffect(() => {
    const _debounce = debounce(formatPageinnation, 500);
    window.addEventListener('resize', _debounce);
    return () => {
      loadedRowsMap = {};
      window.removeEventListener('resize', _debounce);
    };
  }, []);

  useEffect(() => {
    if (!props.cockpitNum) {
      return;
    }
    if (common.connectionState === ConnectionState.OK) {
      formatPageinnation();
    }
  }, [common.connectionState, props.cockpitNum]);

  /**
   * 页面初始化和视口宽高变化时调用
   */
  const formatPageinnation = () => {
    const node = containerRef.current;
    if (node) {
      const rect = node.getBoundingClientRect();
      const { width, height } = rect;
      let col = width / (350 + 16);
      const remainder = width % (350 + 16);
      const rowNum = Math.floor(height / (204 + 16));
      if (remainder > 20 * col) {
        col = Math.floor(width / (370 + 16));
      }
      setContainerHeight(height);
      setPageinnation({
        ...pageinnation,
        pageSize: Math.floor(col * rowNum),
      });
      fetchBoardList(1, Math.floor(col * rowNum));
    }
  };

  const handleInfiniteOnLoad = ({ startIndex, stopIndex }: any) => {
    const max = Math.ceil(
      ((realTimeBoardData && realTimeBoardData.allSize) || 0) /
        pageinnation.pageSize,
    );
    for (let i = startIndex; i <= stopIndex; i++) {
      // 1 means loading
      loadedRowsMap[i] = 1;
    }
    if (boardList.length > max || startIndex === 0) {
      // 已经初始化加载一屏了
      return;
    }
    const pageNum = pageinnation.currentPage + 1;
    setPageinnation({
      ...pageinnation,
      currentPage: pageNum,
    });

    fetchBoardList(pageNum, pageinnation.pageSize);
  };

  useEffect(() => {
    timer && clearTimeout(timer);
    timer = setTimeout(() => {
      clearTimeout(timer);
      fetchBoardList(pageinnation.currentPage, pageinnation.pageSize);
    }, 5000);

    return () => {
      timer && clearTimeout(timer);
    };
  }, [
    realTimeBoardData.timeStamp,
    pageinnation.currentPage,
    pageinnation.pageSize,
    cockpitInfo.currentCockpit.cockpitNumber,
  ]);
  const renderItem = ({ index, key, style }: any) => {
    const item: any = boardList[index] || [];
    return (
      <div style={style} key={key} className='row-group'>
        {item.map((i: any, num: number) => (
          <BoardItem
            key={`${index}_${i.id}_${num}`}
            data={i}
            handleClickStopItem={handleClickStopItem}
            handleScheduleModel={() => {
              props.handleScheduleModel(i.id);
            }}
          />
        ))}
      </div>
    );
  };
  const isRowLoaded = ({ index }: any) => !!loadedRowsMap[index];
  const removeAllAttention = async () => {
    showModal({
      content: '您是否确定将“收藏”都清空？',
      title: '清空收藏',
      footer: {
        showCancel: true,
        showOk: true,
        okFunc: async (cb) => {
          let result = await requestApi.removeAllAttention();
          let newVehicle = JSON.parse(JSON.stringify(vehicle));
          for (let item in newVehicle) {
            newVehicle[item].attentionState = false;
          }
          dispatch(actionMultiVehicle(newVehicle));
          let newStation = JSON.parse(JSON.stringify(station));
          for (let item in newStation) {
            newStation[item].attentionState = false;
          }
          dispatch(actionMultiStation(newStation));
          let newCity = JSON.parse(JSON.stringify(city));
          for (let item in newCity) {
            newCity[item].attentionState = false;
          }
          dispatch(actionMultiCity(newCity));
          if (result.code === HttpStatusCode.Success) {
            message.success('收藏已全部取消！');
          } else {
            message.error('取消全部收藏失败！');
          }
          cb();
        },
        cancelFunc: (cb) => {
          cb();
        },
      },
    });
  };
  return (
    <>
      {searchCondition.currentCategory === 'INTERESTED' && (
        <Button type='primary' onClick={removeAllAttention}>
          清空收藏
        </Button>
      )}
      <div className='board-list' ref={containerRef}>
        {pageinnation.pageSize > 0 && (
          <InfiniteLoader
            isRowLoaded={isRowLoaded}
            loadMoreRows={handleInfiniteOnLoad}
            rowCount={Math.ceil((totalSize || 0) / pageinnation.pageSize) + 1}
            threshold={1}
            minimumBatchSize={1}
            resetLoadMoreRowsCache={true}
          >
            {({ onRowsRendered, registerChild }: any) => {
              return (
                <AutoSizer disableHeight>
                  {({ width }: any) => (
                    <List
                      ref={registerChild}
                      height={containerHeight}
                      onRowsRendered={(_ref: any) => {
                        setPageinnation({
                          ...pageinnation,
                          currentPage: _ref.stopIndex + 1,
                        });
                        onRowsRendered(_ref);
                      }}
                      rowCount={Math.ceil(
                        (totalSize || 0) / pageinnation.pageSize,
                      )}
                      rowHeight={containerHeight}
                      rowRenderer={renderItem}
                      width={width}
                    />
                  )}
                </AutoSizer>
              );
            }}
          </InfiniteLoader>
        )}
      </div>
    </>
  );
};
export default React.memo(BoardMode);
